<div class="category-navigation-container" *ngIf="(nav$ | async) as nav">
  <div class="content">
    <div class="header">
      <div class="title">{{ title }}</div>
      <div class="toggle-option" [ngClass]="noClose ? 'no-close' : '' " (click)="toggleTree()">
        <img src="./assets/ui/shared/icons/drop_down_arrow_down_icon.svg" alt="close" title="close" *ngIf="display === 'none'" />
        <img src="./assets/ui/shared/icons/drop_down_arrow_up_icon.svg" alt="close" title="close" *ngIf="display === 'block'" />
      </div>
    </div>
    <div class="tree" [ngClass]="display">
      <div class="first" [ngClass]="single ? 'single' : ''" *ngFor="let first of nav?.children">
        <a [customRouterLink]="first?.link" [ngClass]="first?.link?.targetUid === page.uid ? 'highlighted' : ''" >{{ first?.link?.title }}</a>
        <div div class="second" *ngFor="let second of first?.children">
          <a [customRouterLink]="second?.link" [ngClass]="second?.link?.targetUid === page.uid ? 'highlighted' : ''" >{{ second?.link?.title }}</a>
          <div div class="third" *ngFor="let third of second?.children">
            <a [customRouterLink]="third?.link" [ngClass]="third?.link?.targetUid === page.uid ? 'highlighted' : ''">{{ third?.link?.title }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
